<template>
    <div class="list-comment">
        <div class="item-comment display-flex">
            <div class="avartar-img">
                <img class="users icon-toggle border-rd-50 p-0"
                    :src="authInfo && authInfo.avatar ? `${uploadUrl}${authInfo.avatar}` : imgAvatar" alt="User" />
            </div>
            <div class="wrap-input-comment">
                <input type="text" class="input-comment" placeholder="Nhấn để bình luận"
                    @keydown.enter="handleAddNewComment" />
            </div>
        </div>
        <div class="wrap-comment" ref="scrollContainer" @scroll="handleScrollComment">
            <div v-for="(item, index) of listDataComment" :key="index">
                <div class="item-comment display-flex margin-top-10">
                    <div class="avartar-img">
                        <img class="users icon-toggle border-rd-50 p-0"
                            :src="item && item.avatar ? `${uploadUrl}${item.avatar}` : imgAvatar" alt="User" />
                    </div>
                    <div class="wrap-info-comment">
                        <div class="name-member">
                            <strong>{{ item.userName }}</strong>
                        </div>
                        <div class="content-comment">
                            {{ item.content }}
                        </div>
                        <div class="footer-comment display-flex justify-content-space-between">
                            <div class="time-comment">
                                {{ moment(item.createAt).format('hh:mm - DD/MM/YYYY') }}
                            </div>
                            <div v-if="item.parentId==0" @click="handleShowFeedback(item)" class="btn-feedback">
                                Phản hồi
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="item.isFeedback" class="item-comment display-flex margin-top-10 margin-left-30">
                    <div class="avartar-img">
                        <img class="users icon-toggle border-rd-50 p-0"
                            :src="authInfo && authInfo.avatar ? `${uploadUrl}${authInfo.avatar}` : imgAvatar"
                            alt="User" />
                    </div>
                    <div class="wrap-input-comment">
                        <input type="text" class="input-comment" placeholder="Nhấn để bình luận"
                            @keydown.enter="handleFeedbackComment($event,item)" />
                    </div>
                </div>
                <div class="item-comment display-flex margin-top-10  margin-left-30" v-for="(child, index) of item.listCommentChild" :key="index">
                    <div class="avartar-img">
                        <img class="users icon-toggle border-rd-50 p-0"
                            :src="child && child.avatar ? `${uploadUrl}${child.avatar}` : imgAvatar" alt="User" />
                    </div>
                    <div class="wrap-info-comment">
                        <div class="name-member">
                            <strong>{{ child.userName }}</strong>
                        </div>
                        <div class="content-comment">
                            {{ child.content }}
                        </div>
                        <div class="footer-comment display-flex justify-content-space-between">
                            <div class="time-comment">
                                {{ moment(child.createAt).format('hh:mm - DD/MM/YYYY') }}
                            </div>
                            
                        </div>
                    </div>
                </div>
                
            </div>

        </div>
    </div>
</template>
<script>
const imgAvatar = require("@/assets/images/HS-2.jpg");
import { getAuth } from "@/utils/jwt";
import { saveLessonCommentClassSchool, listLessonCommentClassSchool } from './../../../_api/lessonCommentClassSchoolServices'
import { APP_CONFIG } from "@/utils/constants";
import moment from "moment";
export default {
    components: {

    },
    data() {
        return {
            moment,
            imgAvatar,
            cdnUrl: APP_CONFIG.cdnUrl,
            uploadUrl: APP_CONFIG.uploadUrl,
            authInfo: {},
            listDataComment: [],
            totalRecords: 0,
            totalPage: 0,
            paramQueryData: {
                lessonClassSchoolId: 0,
                keyword: '',
                pageIndex: 1,
                pageSize: 5,
            },
            isLoading: false,
        }
    },
    mounted() {
        this.authInfo = getAuth()
        this.paramQueryData.lessonClassSchoolId = this.$route.query.id
        this.getLessonCommentClassSchool()
    },
    methods: {
        handleShowFeedback(item){
            item.isFeedback = !item.isFeedback
        },
        handleScrollComment(e) {
            const container = this.$refs.scrollContainer;
            const scrollHeight = container.scrollHeight;
            const scrollTop = container.scrollTop;
            const offsetHeight = container.offsetHeight;
            const bottomOffset = scrollHeight - (scrollTop + offsetHeight);
            if (bottomOffset <= 0 && !this.isLoading) {
                // Load more items when the user reaches the bottom with some offset
                let pageIndexSearch = this.paramQueryData.pageIndex + 1
                if (pageIndexSearch <= this.totalPage) {
                    this.paramQueryData.pageIndex++
                    this.getLessonCommentClassSchool()
                }

            }
        },
        resetData(){
            this.paramQueryData.pageIndex=1
            this.listDataComment = []
        },
        handleFeedbackComment(e,item){
            let value = e.target.value
            let data = {
                content: value,
                lessonClassSchoolId: this.$route.query.id,
                classSchoolId : this.$route.query.classSchoolId,
                parentId: item.id,
            }
            e.target.value = ''
            saveLessonCommentClassSchool(data).then(res => {
                if (res && res.data && !res.errors) {
                    this.$toast.success('Thêm bình luận thành công')
                   this.resetData()
                    this.getLessonCommentClassSchool()
                }
            })
        },
        handleAddNewComment(e) {
            let value = e.target.value
            if(!e.target.value){
                return
            }
            let data = {
                content: value,
                lessonClassSchoolId: this.$route.query.id,
                classSchoolId : this.$route.query.classSchoolId,
                parentId: 0,
            }
            e.target.value = ''
            saveLessonCommentClassSchool(data).then(res => {
                if (res && res.data && !res.errors) {
                    this.$toast.success('Thêm bình luận thành công')
                    this.resetData()
                    this.getLessonCommentClassSchool()
                }
            })
        },
        getLessonCommentClassSchool() {
            let self = this
            let timeCurrent = new Date()
            listLessonCommentClassSchool(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.list.length; i++) {
                        const item = res.data.list[i];
                        if(item.timeAssignEnd){
                            if(moment(item.timeAssignEnd)<moment(timeCurrent)){
                                continue
                            }
                        }
                        self.listDataComment.push({ ...item, isFeedback: false })
                    }

                    self.totalRecords = res.data.paging.totalRecords
                    self.totalPage = res.data.paging.totalPage
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.wrap-comment {
    max-height: 29rem;
    margin-bottom: 10px;
    overflow: auto;
    margin-top: 10px;
}

.content-lesson-planing {
    .list-comment {
        .item-comment {
            padding: 5px;
            border: 1px solid #d9d9d9;
            border-radius: 20px;

            .avartar-img {
                width: 50px;
                height: 40px;
                border-radius: 20px;
            }

            .wrap-info-comment {
                width: 100%;
                margin: 0px 10px 0px 10px;

                .footer-comment {
                    .btn-feedback {
                        cursor: pointer;
                        color: #6f83e1;
                    }
                }
            }

            .wrap-input-comment {
                width: 100%;
                margin: 0px 10px 0px 10px;

                .input-comment {
                    width: 100%;
                    border-radius: 20px;
                    border: 1px solid #d9d9d9;
                    height: 40px;
                }
            }
        }
    }
}

.margin-left-30 {
    margin-left: 30px;
}

.margin-top-10 {
    margin-top: 10px;
}

.justify-content-space-between {
    justify-content: space-between;
}
</style>